import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './CreateCampaign.scss';
import { publicHash, SUCCESS } from '../../utils/constants';
import CreateCampaignForm from './components/CreateCampaignForm/CreateCampaignForm';

class CreateCampaign extends Component {
  static propTypes = {
    getCountries: PropTypes.func.isRequired,
    countries: PropTypes
      .arrayOf(PropTypes.shape({}))
      .isRequired,
    getApps: PropTypes.func.isRequired,
    apps: PropTypes
      .arrayOf(PropTypes.shape({}))
      .isRequired,
    createCampaign: PropTypes.func.isRequired,
    createCampaignStatus: PropTypes.string.isRequired,
    createCampaignError: PropTypes.string.isRequired,
    annulCreateError: PropTypes.func.isRequired,
    campaignId: PropTypes.string.isRequired,
    resetCreateCampaignForm: PropTypes.func.isRequired,
    history: PropTypes
      .shape({
        push: PropTypes.func.isRequired,
        location: PropTypes.shape({}),
      })
      .isRequired,
    setFormState: PropTypes.func.isRequired,
    resetCampaignStore: PropTypes.func.isRequired,
    formState: PropTypes
      .shape({})
      .isRequired,
    isAuthorized: PropTypes.string.isRequired,
    isFirstFlow: PropTypes.bool.isRequired,
    match: PropTypes.shape({}).isRequired,
    getCampaign: PropTypes.func.isRequired,
    updateCampaign: PropTypes.func.isRequired,
    currentEditableCampaign: PropTypes.shape({}).isRequired,
    isAdmin: PropTypes.bool,
    patchCampaign: PropTypes.func.isRequired,
    patchCampaignStatus: PropTypes.string.isRequired,
    patchCampaignError: PropTypes.string.isRequired,
    annulPatchError: PropTypes.func.isRequired,
    sidebarStatus: PropTypes.bool,
    // getCampaignStatus: PropTypes.string.isRequired,
    // getCampaignError: PropTypes.string.isRequired,
  }
  static defaultProps = {
    isAdmin: false,
    sidebarStatus: true,
  }
  componentDidMount() {
    const { getCountries, isFirstFlow } = this.props;
    getCountries();
    if (isFirstFlow) {
      window
        .history
        .pushState(null, null, window.location.href);
      window.onpopstate = () => {
        window
          .history
          .go(1);
      };
    }
  }

  componentDidUpdate(prevProps) {
    const {
      campaignId, history: {
        push,
      }, isFirstFlow, match, isAdmin, patchCampaignStatus, createCampaignStatus,
    } = this.props;
    if (isFirstFlow && campaignId !== prevProps.campaignId && campaignId) {
      push(`${publicHash}/app/media-upload-proposal`);
    }
    if (!isFirstFlow && !match.params.campaignId &&
        campaignId !== prevProps.campaignId && campaignId) {
      push(`${publicHash}/app/media/${match.params.appId}/${campaignId}`);
    }
    if (!isFirstFlow && match.params.campaignId &&
      campaignId !== prevProps.campaignId && campaignId) {
      push(`${publicHash}/app/${match.params.appId}/campaigns`);
    }
    if (!isAdmin && !isFirstFlow &&
      createCampaignStatus !== prevProps.createCampaignStatus && createCampaignStatus === SUCCESS) {
      push(`${publicHash}/app/${match.params.appId}/campaigns`);
    }
    if (isAdmin &&
      patchCampaignStatus !== prevProps.patchCampaignStatus && patchCampaignStatus === SUCCESS) {
      push(`${publicHash}/app/${match.params.appId}/campaigns`);
    }
  }
  componentWillUnmount() {
    const { isFirstFlow, resetCreateCampaignForm } = this.props;
    if (!isFirstFlow) {
      resetCreateCampaignForm();
    }
  }
  render() {
    const {
      countries,
      getApps,
      apps,
      createCampaign,
      createCampaignStatus,
      createCampaignError,
      annulCreateError,
      setFormState,
      resetCampaignStore,
      formState,
      isAuthorized,
      isFirstFlow,
      getCampaign,
      currentEditableCampaign,
      updateCampaign,
      isAdmin,
      match,
      patchCampaign,
      patchCampaignStatus,
      patchCampaignError,
      annulPatchError,
      sidebarStatus,
    } = this.props;

    const campaignClassNames = classNames(['screen', 'create-campaign-screen']);
    return (
      <div className={campaignClassNames}>
        <div className="create-campaign-content">
          <div className="main-label">{match.params.campaignId ? 'Edit campaign' : 'Add Campaign'} </div>
          <CreateCampaignForm
            submitHandler={match.params.campaignId ? updateCampaign : createCampaign}
            countries={countries}
            getApps={getApps}
            apps={apps}
            isAdmin={isAdmin}
            isFirstFlow={isFirstFlow}
            resetCampaignStore={resetCampaignStore}
            setFormState={setFormState}
            createCampaignStatus={createCampaignStatus}
            createCampaignError={createCampaignError}
            annulError={annulCreateError}
            annulPatchError={annulPatchError}
            formState={formState}
            appId={match.params.appId}
            campaignId={match.params.campaignId}
            isAuthorized={isAuthorized}
            currentEditableCampaign={currentEditableCampaign}
            getCampaign={getCampaign}
            patchCampaign={patchCampaign}
            patchCampaignError={patchCampaignError}
            patchCampaignStatus={patchCampaignStatus}
            sidebarStatus={sidebarStatus}
          />
        </div>
      </div>
    );
  }
}

export default CreateCampaign;



// WEBPACK FOOTER //
// ./src/containers/CreateCampaign/CreateCampaign.js